import { render } from "./HsModal.vue?vue&type=template&id=fab2da1e&scoped=true"
import script from "./HsModal.vue?vue&type=script&lang=js"
export * from "./HsModal.vue?vue&type=script&lang=js"

import "./HsModal.vue?vue&type=style&index=0&id=fab2da1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fab2da1e"]])

export default __exports__